<template lang="html">
  <div class="profile-sugestions-wrapper">
    <div class="card">
      <div class="card-header">
        {{ $t('profile.sugestions.sugestions') }}
      </div>
      <div class="card-input-header">
        {{ $t('profile.sugestions.yourSugestion') }}
      </div>
      <textarea
        v-model="sugestion"
        maxlength="254"
        name="name"
        rows="8"
      ></textarea>
      <div @click="send" class="btn">
        {{ $t('main.send') }}
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/api'
export default {
  name: 'profileSugestions',
  data () {
    return {
      sugestion: ''
    }
  },
  methods: {
    send () {
      if (this.sugestion === '') {
        return
      }
      let params = {
        suggestion: this.sugestion
      }
      api
        .setSugestion(params)
        .then(res => {
          console.log(res)
          this.sugestion = ''
          this.$toast.success(this.$t('admin.suggestionSuccess'), {
            duration: 8000
          })
        })
        .catch(e => {
          console.log(e)
          this.$toast.error(this.$t('admin.suggestionError'), {
            duration: 8000
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.profile-sugestions-wrapper {
  padding-left: 40px;
  width: auto;

  .card {
    border: 1px solid rgba(243, 243, 243, 0.7);
    box-sizing: border-box;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.08);
    width: auto;
    max-width: 500px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    @import '@/assets/scss/btnStyles.scss';

    .card-header {
      font-weight: bold;
      font-size: 21px;
      line-height: 34px;
      letter-spacing: 0.06em;
      margin-bottom: 20px;
    }
    .card-input-header {
      font-weight: 600;
      font-size: 13px;
      line-height: 21px;
      letter-spacing: 0.04em;
      color: #606060;
      margin-bottom: 15px;
    }
    textarea {
      width: 100%;
      resize: none;
      border: none;
      border: 1px solid rgba(0, 0, 0, 0.1);
      margin-bottom: 20px;
      outline: none;
      @import '@/assets/scss/scrollbarStyles.scss';
      @include scrollbar;
    }
  }
}
@media screen and (max-width: 1000px) {
  .profile-sugestions-wrapper {
    padding: 0px;

    .card {
      max-width: 100%;
    }
  }
}
</style>
